const PRIMARY_BUTTON = 0;

/** The fields of a click that tell a plain left click from "open in a new tab / window". */
export type ClickModifiers = Pick<MouseEvent, "metaKey" | "ctrlKey" | "shiftKey" | "button">;

/** A plain left click is followed in the app; any other click keeps the browser's behaviour. */
export function isPlainLeftClick(click: ClickModifiers): boolean {
  return !(click.metaKey || click.ctrlKey || click.shiftKey || click.button !== PRIMARY_BUTTON);
}
